module.exports = __webpack_public_path__ + "d064039290a4786ac93978c458426788.svg";